/**
 * Normalizes a date by setting the time components (hours, minutes, seconds, milliseconds) to zero.
 *
 * @param date - The date to normalize. Can be a Date object, string, or undefined (defaults to current date)
 * @returns A new Date object with time components set to 00:00:00.000
 */
export function normalizeDate(date?: string | Date): Date {
  const today =
    typeof date === 'string' && date !== ''
      ? new Date(date)
      : date || new Date();

  today.setHours(0, 0, 0, 0);

  return today;
}
